import Vue from 'vue'
import VueI18n from 'vue-i18n'

import enMessages from './en.js'
import frMessages from './fr.js'

Vue.use(VueI18n)

var lang = window.navigator.userLanguage || window.navigator.language // language du naviguateur ou de l’os

// Check local storage to handle refreshes
// if (window.localStorage) {
//   lang = window.localStorage.getItem('i18nSetting') || lang
// }

if (lang) lang = lang.substr(0, 2)

const i18n = new VueI18n({
  locale: lang || 'fr',
  fallbackLocale: 'fr',
  messages: {
    'en': enMessages,
    'fr': frMessages
  }
})

i18n.selectListLanguages = [
  { text: 'Français', value: 'fr' },
  { text: 'English', value: 'en' }
]

export default i18n
